"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _colors = require("../tokens/colors");
var _spacing = _interopRequireDefault(require("../tokens/spacing"));
var _red = _interopRequireDefault(require("../tokens/color/red"));
var _commonHelper = require("../helpers/commonHelper");
var Link = function Link(props) {
  /** className is passed dynamically by styled components
   * so if we do {...props}, it will apply parent styles to the child as well.
   * it will break the styles of components
   * */

  var Icon = props.icon ? props.icon : null;
  var childProps = (0, _commonHelper.filterChildProps)(props, ["className", "onClick"]);
  return /*#__PURE__*/_react["default"].createElement(Link.Ele, (0, _extends2["default"])({
    href: props.linkTo,
    tabIndex: 0
  }, props), /*#__PURE__*/_react["default"].createElement(Link.Wrapper, (0, _extends2["default"])({
    tabIndex: -1
  }, childProps), props.iconLeft && /*#__PURE__*/_react["default"].createElement(Icon, (0, _extends2["default"])({
    className: "icon-left"
  }, props.iconProps)), props.children, props.iconRight && /*#__PURE__*/_react["default"].createElement(Icon, (0, _extends2["default"])({
    className: "icon-right"
  }, props.iconProps))));
};
Link.Ele = _styledComponents["default"].a.withConfig({
  componentId: "sc-ks3f96-0"
})(["background-color:transparent;font-weight:300;color:", ";text-decoration:none;display:inline-flex;"], function (props) {
  return props.color;
});
Link.Wrapper = _styledComponents["default"].span.withConfig({
  componentId: "sc-ks3f96-1"
})(["display:inline-flex;padding:0.3rem;background-color:", ";cursor:pointer;border:0.1rem solid transparent;border-radius:0.4rem;", ":hover &{color:", ";text-decoration:none;}", ":focus &{border-color:", ";}", ":active &,", ":visited &{color:", ";}line-height:1;.icon-left{transition:0.3s ease;}.icon-right{transition:0.4s ease;}&:hover{.icon-left{margin:0 0.8rem 0 -0.4rem;}.icon-right{margin:0 -1.1rem 0 1.5rem;}}&:focus,&:hover,&:active{text-decoration:none;border-color:transparent;}> i{margin-left:", ";margin-right:", ";}"], function (props) {
  return props.bgColor;
}, Link.Ele, function (props) {
  return props.hoverColor;
}, Link.Ele, _red["default"].z300, Link.Ele, Link.Ele, function (props) {
  return props.activeColor;
}, function (props) {
  return props.iconRight ? _spacing["default"].xxsmall : 0;
}, function (props) {
  return props.iconLeft ? _spacing["default"].xxsmall : 0;
});
Link.propTypes = {
  /** forwarding link */
  linkTo: _propTypes["default"].string,
  /** value for window.taget */
  target: _propTypes["default"].oneOf(["_self", "_blank", "_parent", "_top"]),
  /** title of link, mandatory for accessebility */
  title: _propTypes["default"].string.isRequired,
  onClick: _propTypes["default"].func,
  /** for accessebility */
  role: _propTypes["default"].string,
  color: _propTypes["default"].string,
  /** Text color on hover */
  hoverColor: _propTypes["default"].string,
  /** Text color on active state */
  activeColor: _propTypes["default"].string,
  bgColor: _propTypes["default"].string,
  iconLeft: _propTypes["default"].bool,
  iconRight: _propTypes["default"].bool,
  /** Icon component you want to show*/
  icon: _propTypes["default"].func,
  /** props for icon component you want to show*/
  iconProps: _propTypes["default"].objectOf(_propTypes["default"].any),
  children: _propTypes["default"].any
};
Link.defaultProps = {
  target: "_self",
  role: "link",
  color: _colors.link["default"],
  hoverColor: _colors.link["default"],
  activeColor: _colors.link.defaultActive,
  bgColor: "transparent",
  iconLeft: false,
  iconRight: false,
  icon: null,
  iconProps: {},
  children: null
};
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(Link);